import { useCallback } from "react";

export const SUGGEST_FEATURE_URL =
  "https://airtable.com/appZfcDAz1L29UCaV/pagolHzsds57mNivt/form";

export const useSuggestFeature = () =>
  useCallback(() => {
    window.open(SUGGEST_FEATURE_URL, "_blank");
  }, []);
